import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InventoryListRangeReport  {
    _originalTypeClassName = "zERP.BO.InventoryListRangeReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InventoryListRangeReport.translate = translateService;
}
this.Goods = [];
this.DateFrom = null;
this.DateTo = null;
this.GoodsCount = null;
this.TotalPreviousAmount = null;
this.TotalPreviousValue = null;
this.TotalImportAmount = null;
this.TotalImportValue = null;
this.TotalExportAmount = null;
this.TotalExportValue = null;
this.TotalAmount = null;
this.TotalValue = null;
this.UnmovedPreviousAmount = null;
this.UnmovedPreviousValue = null;
this.UnmovedImportAmount = null;
this.UnmovedImportValue = null;
this.UnmovedExportAmount = null;
this.UnmovedExportValue = null;
this.UnmovedAmount = null;
this.UnmovedValue = null;
this.InventoryListRangeReportKey = null;
this._key = this.InventoryListRangeReportKey = 0; 
}

static translate: TranslateService;
_key: any;
DateFrom:any;
DateTo:any;
GoodsCount:any;
TotalPreviousAmount:any;
TotalPreviousValue:any;
TotalImportAmount:any;
TotalImportValue:any;
TotalExportAmount:any;
TotalExportValue:any;
TotalAmount:any;
TotalValue:any;
UnmovedPreviousAmount:any;
UnmovedPreviousValue:any;
UnmovedImportAmount:any;
UnmovedImportValue:any;
UnmovedExportAmount:any;
UnmovedExportValue:any;
UnmovedAmount:any;
UnmovedValue:any;
Goods:any;
private _InventoryListRangeReportKey:any;
get InventoryListRangeReportKey(): any {
    return this._InventoryListRangeReportKey;
  }
set InventoryListRangeReportKey(value: any) {
    this._InventoryListRangeReportKey = value;
    this._key = value;
  }
static setGoods = ($this, items) => {
                if (items == null) items = [];
                if ($this.Goods == null) $this.Goods = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Goods.length > 0) {
                    Domain.InventoryListRangeReport.removeGoods($this, $this.Goods[0]);
                }

                Domain.InventoryListRangeReport.addManyGoods($this, copyItems);
            }
static addManyGoods = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InventoryListRangeReport.addGoods($this, items[i]);
                }
            }
static addGoods = ($this, item) => {
                if ($this.Goods == null) $this.Goods = [];
                if (item == null || $this.Goods.indexOf(item) > -1) return;
                $this.Goods.push(item);
}
static addRangeGoods = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InventoryListRangeReport.addGoods($this, item));
            }
static removeGoods = ($this, item) => {
                if ($this == null || $this.Goods == null || $this.Goods.indexOf(item) === -1) return;
                var _index = $this.Goods.indexOf(item);
                $this.Goods.splice(_index, 1);
}
static clearGoods = ($this) => { $this.Goods = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.InventoryListRangeReportKey == null || $this.InventoryListRangeReportKey == 0;
            }


}